import React from "react";

/** 出租率进度条参考宽度（px）：全店 quantity 占满此宽度，其余按比例换算 */
const BAR_REFERENCE_WIDTH = 100;

interface ProgressCellProps {
  progress: number;
  quantity: number;
  quantityOpen: number;
  maxQuantity: number;
  strokeColor?: string;
}

/**
 * 进度条单元格
 * - 灰色条宽度 = (quantity / maxQuantity) * BAR_REFERENCE_WIDTH
 *   全店 = 所有房型 quantity 之和，占满 100；其余行为该房型自己的 quantity
 * - 蓝色条暂不处理（先保证灰色宽度正确）
 */
export const ProgressCell: React.FC<ProgressCellProps> = ({
  progress,
  quantity,
  quantityOpen,
  maxQuantity,
  strokeColor = "#1890ff",
}) => {
  const soldQuantity = Math.max(0, quantity - (quantityOpen ?? 0));

  // 灰色条：quantity 换算后的长度，100 代表 maxQuantity
  // 全店（quantity = maxQuantity）占满 100px，其余行按 quantity 比例换算
  const greyPx =
    maxQuantity > 0 && quantity > 0
      ? (quantity / maxQuantity) * BAR_REFERENCE_WIDTH
      : 0;

  // 蓝色条：(quantity - quantityOpen) 换算后的长度，占灰色条的比例 = 出租率
  const bluePx =
    maxQuantity > 0 && soldQuantity > 0
      ? (soldQuantity / maxQuantity) * BAR_REFERENCE_WIDTH
      : 0;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        width: "100%",
        minWidth: 0,
      }}
    >
      {/* 进度条容器：宽度等于灰色条宽度（该房型的 quantity） */}
      <div
        style={{
          width: `${greyPx}px`,
          flexShrink: 0,
          position: "relative",
          height: 8,
          backgroundColor: "#e8e8e8", // 灰色背景就是容器本身
          borderRadius: 4,
          overflow: "hidden",
          minWidth: greyPx > 0 ? '1px' : '0px',
        }}
      >
        {/* 蓝色条：已售房间数换算后的长度，覆盖在灰色背景上 */}
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: `${bluePx}px`,
            height: "100%",
            backgroundColor: strokeColor,
            borderRadius: 4,
            transition: "width 0.2s ease",
          }}
        />
      </div>
      <span
        style={{
          fontSize: 12,
          color: "#666",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        {Math.max(0, Math.min(100, progress)).toFixed(1)}%
      </span>
    </div>
  );
};
